import { SwiperSlideProps } from "swiper/react";

export function SwiperSlide(props: SwiperSlideProps) {
  const { children, className, ...rest } = props;
  const classname = {
    class: className,
  };

  return (
    <swiper-slide {...classname} {...rest}>
      {children}
    </swiper-slide>
  );
}
